import {button,escapeHtml,message,panel,statusPill} from '../ui/components.js';
import {errorState,loadingState} from '../ui/states.js';
import {DymekPrivacyDisclosure} from './privacy.js';

const CLASS_LABELS=Object.freeze({
  observed:'Z danych',
  validated_knowledge:'Zweryfikowana zasada',
  derived_calculation:'Obliczenie',
  general_suggestion:'Sugestia'
});

function evidenceLabel(value){
  return CLASS_LABELS[String(value||'')]||'Informacja';
}
function contextHeader(state){
  return '<div class="dymek-context"><div><span class="eyebrow">Kontekst</span><strong>'
    +escapeHtml(state.contextLabel||'Dymistrz')
    +'</strong></div>'+statusPill([
      state.context?.surface||'home',
      'bez autonomicznych zmian'
    ])+'</div>';
}
function promptButtons(state){
  return '<div class="dymek-suggestions">'+(state.suggestedPrompts||[]).map(prompt=>
    button({
      label:prompt,
      variant:'secondary',
      attributes:{'data-dymek-prompt':prompt}
    })
  ).join('')+'</div>';
}
function linkMarkup(link){
  return '<button class="button button-ghost" type="button" data-dymek-open-kind="'
    +escapeHtml(link.kind)+'" data-dymek-open-ref="'+escapeHtml(link.ref)+'">'
    +escapeHtml(link.label)+'</button>';
}
function responseMarkup(response){
  if(!response)return '';
  if(response.status==='fallback'){
    return message({
      kind:'warning',
      text:'Brakuje zweryfikowanej wiedzy potrzebnej do bezpiecznej odpowiedzi. Dymek nie będzie zgadywał.'
    });
  }
  const claims=(response.claims||[]).map(claim=>
    '<article class="dymek-claim"><div class="dymek-claim-head"><span class="dymek-evidence">'
      +escapeHtml(evidenceLabel(claim.evidenceClass))+'</span>'
      +(claim.safetyCritical?'<span class="dymek-safety">bezpieczeństwo</span>':'')
      +'</div><p>'+escapeHtml(claim.content)+'</p>'
      +(claim.assumptions?.length
        ?'<details><summary>Założenia</summary><p>'+escapeHtml(claim.assumptions.join(' · '))+'</p></details>'
        :'')
      +'</article>'
  ).join('');
  const links=(response.links||[]).length
    ?'<div class="actions dymek-links">'+response.links.map(linkMarkup).join('')+'</div>'
    :'';
  return claims+links;
}
function messageMarkup(item){
  if(item.role==='user'){
    return '<article class="dymek-message dymek-message-user"><span>Ty</span><p>'
      +escapeHtml(item.prompt||'')+'</p></article>';
  }
  if(item.streamText!=null){
    return '<article class="dymek-message dymek-message-assistant is-streaming"><span>Dymek</span><p>'
      +escapeHtml(item.streamText||'')+'<span aria-hidden="true">…</span></p></article>';
  }
  if(item.errorCode){
    return '<article class="dymek-message dymek-message-assistant"><span>Dymek</span><p>'
      +'Odpowiedź nie została zakończona. Kod: '+escapeHtml(item.errorCode)+'</p></article>';
  }
  const feedback=item.interactionId&&item.response
    ?item.feedback==null
      ?'<div class="actions dymek-feedback" aria-label="Oceń odpowiedź">'
        +button({
          label:'Pomocne',
          variant:'ghost',
          attributes:{
            'data-dymek-feedback':'1',
            'data-dymek-interaction':item.interactionId
          }
        })
        +button({
          label:'Niepomocne',
          variant:'ghost',
          attributes:{
            'data-dymek-feedback':'0',
            'data-dymek-interaction':item.interactionId
          }
        })
        +'</div>'
      :'<p class="auth-note">Ocena zapisana: '+(item.feedback?'pomocne':'niepomocne')+'.</p>'
    :'';
  return '<article class="dymek-message dymek-message-assistant"><span>Dymek</span>'
    +responseMarkup(item.response)+feedback+'</article>';
}
function historyChoices(state){
  if(state.kind!=='history_selection')return '';
  return panel({
    title:'Wybierz dwie sesje',
    subtitle:'Dymek porówna wyłącznie zaznaczone próby. Prywatne wnioski nie są dołączane bez potrzeby.',
    body:'<form id="dymek-history-form" class="dymek-history-form">'
      +(state.historyChoices||[]).map(choice=>
        '<label class="planner-check"><input type="checkbox" name="sessionId" value="'
        +escapeHtml(choice.id)+'"> <span>'
        +escapeHtml((choice.completedAt||'bez daty')+' · '+(choice.title||'Wędzenie'))
        +(choice.outcome?.overallRating!=null?' · ocena '+escapeHtml(choice.outcome.overallRating):'')
        +'</span></label>'
      ).join('')
      +'<div class="actions">'+button({label:'Porównaj zaznaczone',type:'submit',variant:'primary'})+'</div>'
      +'</form>'
  });
}
function composer(state){
  const disabled=state.kind==='streaming';
  return '<form id="dymek-prompt-form" class="dymek-composer">'
    +'<label class="field"><span class="field-label">Zapytaj Dymka</span>'
    +'<textarea name="prompt" rows="3" maxlength="4000" required placeholder="Np. jaka jest ostatnia zapisana temperatura?"></textarea></label>'
    +'<label class="planner-check"><input type="checkbox" name="privateTextNeeded" value="1"> '
    +'<span>Dołącz prywatne notatki tylko do tego pytania</span></label>'
    +'<label class="planner-check"><input type="checkbox" name="providerProcessingConsent" value="1"> '
    +'<span>Jeśli potrzebny jest zewnętrzny model AI, pozwól wysłać to pytanie i minimalny kontekst do skonfigurowanego dostawcy</span></label>'
    +'<div class="actions">'
    +button({label:disabled?'Dymek odpowiada…':'Wyślij',type:'submit',variant:'primary',disabled})
    +button({id:'dymek-new-topic',label:'Nowy temat',variant:'secondary',disabled})
    +button({id:'dymek-clear-conversation',label:'Wyczyść rozmowę',variant:'ghost',disabled})
    +(state.kind==='error'?button({id:'dymek-retry',label:'Ponów',variant:'secondary'}):'')
    +'</div></form>';
}

export function renderDymekPage(state){
  if(!state)return loadingState({title:'Ładowanie Dymka'});
  const conversation=(state.messages||[]).length
    ?'<section class="dymek-conversation">'+state.messages.map(messageMarkup).join('')+'</section>'
    :panel({
      title:'Dymek korzysta z kontekstu produktu',
      subtitle:'Najpierw fakty z Dymistrza, potem zweryfikowana wiedza. Sugestie są oznaczone i niczego nie zmieniają automatycznie.',
      body:promptButtons(state)
    });

  const loading=state.kind==='streaming'
    ?message({kind:'neutral',text:'Dymek sprawdza dostępny kontekst i klasy dowodów…'})
    :'';
  const error=state.kind==='error'
    ?errorState({
      title:'Odpowiedź nie została ukończona',
      text:'Dane sesji nie zostały zmienione. Możesz ponowić odpowiedź.'
    })
    :'';

  const privacy=panel({
    title:DymekPrivacyDisclosure.title,
    subtitle:DymekPrivacyDisclosure.summary,
    body:'<p class="panel-copy">'+escapeHtml(DymekPrivacyDisclosure.privateText)+'</p>'
      +'<p class="panel-copy">'+escapeHtml(DymekPrivacyDisclosure.provider)+'</p>'
      +'<p class="panel-copy">'+escapeHtml(DymekPrivacyDisclosure.analytics)+'</p>'
      +'<p class="panel-copy">'+escapeHtml(DymekPrivacyDisclosure.delete)+'</p>'
  });
  return '<section class="dymek-page">'
    +contextHeader(state)
    +message({text:state.notice||'',kind:state.noticeKind||'neutral'})
    +privacy
    +conversation
    +historyChoices(state)
    +loading
    +error
    +composer(state)
    +'</section>';
}
